import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";

export default function TopicCard({ topic }: { topic: Topic }) {
  return (
    <article className="group flex flex-col h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
      <Link to={`/topic/${topic.id}`} className="flex flex-col h-full">
        <div className="relative w-full h-44 md:h-48 overflow-hidden">
          <img
            src={topic.cover}
            alt={`${topic.title}事件合集封面`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs">
            {topic.category}
          </span>
          <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 text-xs text-background-100">
            <i className="ri-fire-line text-accent-400"></i>
            热度 {(topic.heat / 10000).toFixed(1)}万
          </span>
        </div>
        <div className="p-4 md:p-5 flex flex-col flex-1">
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {topic.title}
          </h3>
          <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
            {topic.summary}
          </p>
          <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-refresh-line text-accent-600"></i>
              {topic.updateCount} 次更新
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              {topic.lastUpdate}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}